import React from 'react';
import { connect } from 'react-redux';
import StatisticsContent from './StatisticsContent.js';
import { actions } from './StatisticsContent.actions';

const StatisticsContentComponent = connect(
    function mapStateToProps(state) {
        const reportMetrics = state?.statistics?.data?.parameters?.metricsBinary
            || state?.serverStorage?.store?.report?.metrics;
        return {
            loadingData: state.statistics.data.loading,
            totalPages: state.statistics.data.total,
            page: state.statistics.data.page,
            user: state.user,
            metrics: typeof reportMetrics === 'string' ? reportMetrics : '',
            serverStorageReady: !!state.serverStorage.loaded
        };
    },
    function mapDispatchToProps(dispatch) {
        return {
            search: actions.search,
            searchChart: actions.searchChart,
            setQuery: actions.setQuery
        };
    }
)(StatisticsContent);

export default StatisticsContentComponent;
